export default __webpack_public_path__ + "static/media/PUPipeinsulationwithAluminumClading.d8cc36f9.jpg";